const STORAGE_KEY = 'reflectlogs_token';

const tokenStorage = {
  get() {
    try {
      return sessionStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  },
  set(token) {
    try {
      sessionStorage.setItem(STORAGE_KEY, token);
    } catch {
      // Storage not available
    }
  },
  remove() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      // Storage not available
    }
  }
};

export default tokenStorage;
